import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const MOSAIC_LEGACY_FIELD_ORDER = [
  "cards",
  { type: "separator" },
  "top_margin",
  "bottom_margin",
  "background_color",
  "full_width",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  mosaicBlockDescriptor: _generatedMosaicBlockDescriptor,
  mosaicBlockBlocDefinition,
  mosaicBlockDashboardLayout,
  mosaicBlockConfig,
  mosaicBlockResolveConfig,
  mosaicBlockProperties,
} = doodBlockConfig(
  {
    name: "Mosaic",
    componentType: "MosaicBlockComponent",
    category: "layout",
    description: "Container for Mosaic card blocks.",
    keywords: ["mosaic", "cards", "layout"],
    sharedFields: {},
    slots: [
      {
        key: "cards",
        name: "pages.blocks.mosaic.cards.label",
        accept: "explicitOnly",
        // CB1 picker matches ALLOWED_BLOCKS keys (`MosaicCardBlock`), not
        // component class names. CB2 `matchesAllowedType` still accepts both.
        allowedTypes: [
          "MosaicCardBlock",
          "MosaicComoCreateAccountCardBlock",
          "MosaicComoLinkAccountCardBlock",
        ],
        slotItemFormat: "positionedBlocks",
      },
    ],
  },

  () => ({
    top_margin: propertyValue({ type: "select", value: "medium", options: { label: "pages.blocks.mosaic.top-margin.label", choices: [{ value: "none", label: "pages.blocks.mosaic.top-margin.options.none" }, { value: "small", label: "pages.blocks.mosaic.top-margin.options.small" }, { value: "medium", label: "pages.blocks.mosaic.top-margin.options.medium" }, { value: "large", label: "pages.blocks.mosaic.top-margin.options.large" }] } }),
    bottom_margin: propertyValue({ type: "select", value: "medium", options: { label: "pages.blocks.mosaic.bottom-margin.label", choices: [{ value: "none", label: "pages.blocks.mosaic.bottom-margin.options.none" }, { value: "small", label: "pages.blocks.mosaic.bottom-margin.options.small" }, { value: "medium", label: "pages.blocks.mosaic.bottom-margin.options.medium" }, { value: "large", label: "pages.blocks.mosaic.bottom-margin.options.large" }] } }),
    background_color: propertyValue({ type: "color", value: { type: "hex", value: "transparent" }, options: { label: "pages.blocks.mosaic.background-color.label" } }),
    full_width: propertyValue({ type: "checkbox", value: false, options: { label: "pages.blocks.mosaic.full-width.label" } }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.mosaic.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.mosaic.fieldset.cards.label",
            fields: ["cards"],
          },
          {
            legend: "pages.blocks.mosaic.fieldset.layout.label",
            fields: [
              "top_margin",
              "bottom_margin",
              "full_width",
              "background_color",
            ],
          },
        ],
      },
    ],
  })
);

export function mosaicBlockDescriptor(): IBlockDescriptor;
export function mosaicBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function mosaicBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMosaicBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedMosaicBlockDescriptor,
    mosaicBlockProperties,
    fieldOrder,
  );
}

export {
  mosaicBlockBlocDefinition,
  mosaicBlockDashboardLayout,
  mosaicBlockConfig,
  mosaicBlockResolveConfig,
  mosaicBlockProperties,
};

export type MosaicBlockConfig = typeof mosaicBlockConfig;
